export default "__VITE_ASSET__DnuUPtwU__"